import { render, staticRenderFns } from "./LocalPalletsInfo.vue?vue&type=template&id=877c404c&scoped=true"
import script from "./LocalPalletsInfo.vue?vue&type=script&lang=js"
export * from "./LocalPalletsInfo.vue?vue&type=script&lang=js"
import style0 from "./LocalPalletsInfo.vue?vue&type=style&index=0&id=877c404c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877c404c",
  null
  
)

export default component.exports